import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const obtenerIngresoUrl = "api/v1/websalud/primeraars/ingreso";
const obtenerReclamosIngresoUrl = "api/v1/websalud/primeraars/ingreso/reclamos";
const validarCoberturaIngresoUrl =
  "api/v1/websalud/primeraars/ingreso/cobertura/validacion";
const insertarCoberturaIngresoUrl =
  "api/v1/websalud/primeraars/ingreso/cobertura";
const eliminarCoberturaIngresoUrl =
  "api/v1/websalud/primeraars/ingreso/cobertura/eliminar";
const generarCierreCuentaUrl =
  "api/v1/websalud/primeraars/ingreso/cuenta/cerrar";
const consultarCierresCuentasUrl =
  "api/v1/websalud/primeraars/ingreso/cuentas/cierre";
const consultarCoberturasCierreUrl =
  "api/v1/websalud/primeraars/ingreso/coberturas";
const consultarReclamantesUrl =
  "api/v1/websalud/primeraars/ingreso/reclamantes";
const calcularOxigenoUrl = "api/v1/websalud/primeraars/ingreso/oxigeno/calculo";
const consultarPacientesIngresadosUrl = "api/v1/websalud/primeraars/ingreso/lista";
const obtenerCamposHojaQuirurgicaUrl = "api/v1/websalud/primeraars/validacion-hoja-quirurgica/campos";
const buscarSolicitudesHojaQuirurgicaUrl = "api/v1/websalud/primeraars/validacion-hoja-quirurgica/buscar";
const obtenerDetalleSolicitudHojaQuirurgicaUrl = (numeroSolicitud) =>
  `api/v1/websalud/primeraars/validacion-hoja-quirurgica/${numeroSolicitud}/detalle`;
const descargarAdjuntoHojaQuirurgicaUrl = (id) =>
  `api/v1/websalud/primeraars/validacion-hoja-quirurgica/adjunto/${id}/descargar`;

const obtenerCamposHojaQuirurgica = () =>
  InterceptToken(BaseApi.get, obtenerCamposHojaQuirurgicaUrl).then(
    (response) => response.data
  );

const subirAdjuntoHojaQuirurgicaUrl = "api/v1/websalud/primeraars/validacion-hoja-quirurgica/adjuntos";

const subirAdjuntoHojaQuirurgica = (formData) =>
  InterceptToken(BaseApi.post, subirAdjuntoHojaQuirurgicaUrl, formData).then(
    (response) => response.data
  );

const crearSolicitudHojaQuirurgicaUrl = "api/v1/websalud/primeraars/validacion-hoja-quirurgica";

const crearSolicitudHojaQuirurgica = (request) =>
  InterceptToken(BaseApi.post, crearSolicitudHojaQuirurgicaUrl, request).then(
    (response) => response.data
  );

const obtenerIngreso = (request) =>
  InterceptToken(BaseApi.get, obtenerIngresoUrl, request).then(
    (response) => response.data
  );

const consultarCierresCuentas = (request) =>
  InterceptToken(BaseApi.get, consultarCierresCuentasUrl, request).then(
    (response) => response.data
  );

const consultarCoberturasCierre = (request) =>
  InterceptToken(BaseApi.get, consultarCoberturasCierreUrl, request).then(
    (response) => response.data
  );

const consultarReclamantes = (request) =>
  InterceptToken(BaseApi.get, consultarReclamantesUrl, request).then(
    (response) => response.data
  );

const validarCoberturaIngreso = (request) =>
  InterceptToken(BaseApi.post, validarCoberturaIngresoUrl, request).then(
    (response) => response.data
  );

const insertarCoberturaIngreso = (request) =>
  InterceptToken(BaseApi.post, insertarCoberturaIngresoUrl, request).then(
    (response) => response.data
  );

const eliminarCoberturaIngreso = (request) =>
  InterceptToken(BaseApi.post, eliminarCoberturaIngresoUrl, request).then(
    (response) => response.data
  );

const generarCierreCuenta = (request) =>
  InterceptToken(BaseApi.post, generarCierreCuentaUrl, request).then(
    (response) => response.data
  );

const obtenerReclamosIngreso = (request) =>
  InterceptToken(BaseApi.get, obtenerReclamosIngresoUrl, request).then(
    (response) => response.data
  );

const calcularOxigeno = (request) =>
  InterceptToken(BaseApi.post, calcularOxigenoUrl, request).then(
    (response) => response.data
  );

const consultarPacientesIngresados = (request) =>
  InterceptToken(BaseApi.get, consultarPacientesIngresadosUrl, request).then(
    (response) => response.data
  );

const buscarSolicitudesHojaQuirurgica = (request) =>
  InterceptToken(BaseApi.get, buscarSolicitudesHojaQuirurgicaUrl, request).then(
    (response) => response.data
  );

const obtenerDetalleSolicitudHojaQuirurgica = (numeroSolicitud) =>
  InterceptToken(
    BaseApi.get,
    obtenerDetalleSolicitudHojaQuirurgicaUrl(numeroSolicitud)
  ).then((response) => response.data);

const descargarAdjuntoHojaQuirurgica = (id, numeroSolicitud) =>
  InterceptToken(
    BaseApi.get,
    descargarAdjuntoHojaQuirurgicaUrl(id),
    numeroSolicitud ? { numeroSolicitud } : null,
    { responseType: "blob" }
  ).then((response) => response.data);

const actualizarSolicitudHojaQuirurgicaUrl = (numeroSolicitud) =>
  `api/v1/websalud/primeraars/validacion-hoja-quirurgica/${numeroSolicitud}`;

const actualizarSolicitudHojaQuirurgica = (numeroSolicitud, formData) =>
  InterceptToken(
    BaseApi.put,
    actualizarSolicitudHojaQuirurgicaUrl(numeroSolicitud),
    formData
  ).then((response) => response.data);

const exportedObject = {
  obtenerIngreso,
  validarCoberturaIngreso,
  insertarCoberturaIngreso,
  eliminarCoberturaIngreso,
  generarCierreCuenta,
  consultarCierresCuentas,
  consultarCoberturasCierre,
  consultarReclamantes,
  obtenerReclamosIngreso,
  calcularOxigeno,
  consultarPacientesIngresados,
  obtenerCamposHojaQuirurgica,
  subirAdjuntoHojaQuirurgica,
  crearSolicitudHojaQuirurgica,
  buscarSolicitudesHojaQuirurgica,
  obtenerDetalleSolicitudHojaQuirurgica,
  descargarAdjuntoHojaQuirurgica,
  actualizarSolicitudHojaQuirurgica
};

export default exportedObject;
